import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';

import { KPIWidget } from 'scenes/KPI/Widget';
import {
  SCREEN_NAME as nameKPI,
  permission as permissionKPI,
} from 'scenes/KPI/constants';
import { HourlyTrackerWidget } from 'scenes/Trackers/HourlyTracker/Widget';
import {
  SCREEN_NAME as nameHourlyTracker,
  permission as permissionHourlyTracker,
} from 'scenes/Trackers/HourlyTracker/constants';
import { TrackerWidget } from 'scenes/Trackers/Tracker/Widget';
import {
  SCREEN_NAME as nameTracker,
  permission as permissionTracker,
} from 'scenes/Trackers/Tracker/constants';

const widgets = [
  {
    title: 'Tracker',
    name: nameTracker,
    permission: permissionTracker,
    Widget: TrackerWidget,
  },
  {
    title: 'KPIs',
    name: nameKPI,
    permission: permissionKPI,
    Widget: KPIWidget,
  },
  {
    title: 'HR Tracker',
    name: nameHourlyTracker,
    permission: permissionHourlyTracker,
    Widget: HourlyTrackerWidget,
  },
];

export const widgetNames = widgets.map(({ name }) => name);

export const getWidgetByName = (widgetName) => {
  const widget = widgets.find(({ name }) => name === widgetName);
  return widget ? widget.Widget : null;
};

export const getWidgetsData = (options, isAllowed) => {
  const optionGroups = groupBy(options, 'screen');

  return widgets
    .map(({ name, title, permission }) => {
      const isAllowedWidget = isAllowed([permission]);
      const dataWidget = optionGroups[name];
      return isAllowedWidget && !isEmpty(dataWidget)
        ? {
            name,
            title,
            data: dataWidget,
          }
        : null;
    })
    .filter((i) => i);
};
